import React, { useCallback } from 'react';
import {    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,
    Edit, SimpleForm, TextInput,SelectInput,
    DateInput, BooleanInput, NumberInput,ReferenceInput,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton,FormDataConsumer
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { makeStyles } from '@material-ui/core/styles';
import { AddressFields } from './AddressFields';


const useStyles = makeStyles(theme => ({
    subjectid:{
        display:'inline-block'
    }, 
    title: {
        display:'inline-block',
        marginLeft: '20px',
        width:'300px'
    }
}));

export const ZipCodeEdit = props => {
    const classes = useStyles({});
    return (
        <Edit {...props} title="ZipCode">
            <SimpleForm redirect="list"  
            variant="outlined">
                <FormDataConsumer>
            {formDataProps => (
              <AddressFields {...formDataProps} />
            )}
          </FormDataConsumer>
            <TextInput validate={required()} source="zipCode" label="ZipCode" fullWidth={true} /> 
            
            <BooleanInput initialValue={true} source="isActive" />
            </SimpleForm>
        </Edit>
    );
}